import { RefObject, useLayoutEffect, useRef } from 'react';

import { ResizeObserver } from '@/compatibility/resizeObserver';

type THandler = (entry: ResizeObserverEntry) => void;

export const useResizeObserver = (ref: RefObject<HTMLElement>, handler: THandler) => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useLayoutEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      handlerRef.current(entry);
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref]);
};
